import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { BillingPlanPartsDataGrid } from "src/components/views/erp/sales/billingPlan/part/BillingPlanPartsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/billingPlanParts")({
	staticData: { title: i18n.t("billing_products"), legacyViewKey: "billingPlanPartsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <BillingPlanPartsDataGrid />;
}
